import { z } from 'zod';
export const AchievementTypeParamSchema = z.object({
    type: z.enum(['projects', 'awards', 'conferences', 'bibliography'])
});
//# sourceMappingURL=achievementTypeParamSchema.js.map